<template>
  <!-- <v-form ref="form" v-model="validForm"> -->
    <v-autocomplete
      v-model="tipoGeneracionSelect"
      @change="change"
      :items="tiposGeneraciones"
      item-text="descripcion"
      item-value="id"
      dense
      filled
      label="Tipo Generacion"
      :return-object="returnObject"
      :rules="rules"
      :clearable="clearable"
      :disabled="disabled"
    ></v-autocomplete>
   
  <!-- </v-form> -->
</template>
<script>
import axios from "axios";

export default {
  props: {
    filtroId: { type: Array, default: null },
    tipoGeneracion: {type: Object, default: null},
    returnObject: {type: Boolean, default: true },
    clearable: { type: Boolean, default: false } ,
    disabled: { type: Boolean, default: false } ,
    rules: { type: Array },
  },
  data() {
    return {
      tiposGeneraciones: [],
      tipoGeneracionSelect: null,
      // validForm: false,
      // rules: {
      //   required: (value) => !!value || "Requerido.",
      //   counter: (value) =>
      //     (value && value.length <= 1000) || "Maximo 100 caracteres",
      //   counter10: (value) =>
      //     (value && value.length <= 10) || "Maximo 10 caracteres",
      // },
    };
  },
  mounted() {
   
    if (this.tipoGeneracion) {
      this.tipoGeneracionSelect = this.tipoGeneracion;
    } 
    axios
      .get("/tipoGeneracion")
      .then((response) => {
        console.log(response);
        if (this.filtroId) {
          this.tiposGeneraciones = response.data.filter((gen) =>
            this.filtroId.includes(gen.id)
          );
        } else {
          this.tiposGeneraciones = response.data;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    change() {
      this.$emit('tipoGeneracion', this.tipoGeneracionSelect)
    }
  }
};
</script>